export default {
  en: {
    'pages.draft-return.make-adjustments-option': 'This draft has the option to make adjustments',
    'pages.draft-return.upload-modal': 'Do you want to upload the return?',
    'pages.draft-return.tax-codes-not-included':
      'The following tax codes are not incorporated into this return:',
    'pages.draft-return.send-electronically': 'Send draft to HMRC',
    'pages.draft-return.send-elster-electronically': 'Send draft to Elster',
    'pages.draft-return.has-account':
      'I confirm that my client has received a copy of the information contained in this return and approved\n' +
      'the information as being correct and complete to the best of their knowledge and belief.',
    'pages.draft-return.doesnt-have-account':
      'When you submit this VAT information you are making a legal declaration that the information is true\n' +
      'and complete. A false declaration can result in prosecution.',
    'pages.draft-return.filing-submitted-on': 'Submitted on:',
    'pages.draft-return.submitted-by': 'Submitted by:',
    'pages.draft-return.hmrc-id': 'HMRC receipt ID:',
    'pages.draft-return.elster-id': 'Elster receipt ID:',
    'pages.draft-return.manual.saved': 'Saved Successfully',
    'pages.draft-return.manual.save-failure': 'Error saving changes',
    'pages.draft-return.fiscale': 'Fiscale code:',
    'pages.draft-return.calc': 'Pre-Payment calculation method:',
    'pages.draft-return.no-file-available': 'File is not available',
    'pages.draft-return.germany.submit-to-elster.address-warning':
      'Note: This entity does not have an address associated with it. In order to continue, you need to have a valid address.',
    'pages.draft-return.germany.submit-to-elster.change-password': 'Change password',
  },
};
